import nhcLogo from '../assets/nhc-logo.png';
import nhcLogoDark from '../assets/nhc-logo-dark.png';
import nhcLogoOnBrand from '../assets/nhc-logo-on-brand.png';

/**
 * The New Horizon Copper mark, in the cut that suits the surface behind it.
 *
 * The supplied artwork is a small raster flattened onto white, with a navy
 * wordmark. Dropping it straight into a dark header put a white sticker in the
 * bar. Alpha was recovered from the flatten and the wordmark recoloured for
 * dark surfaces; `onDark` forces that cut for panels that are dark in both
 * themes, like the sign-in brand panel.
 *
 * That dark cut still carried the original artwork's muted navy and olive
 * strokes, tuned for a neutral dark background: on the brand panel's dark
 * red they read as dark-on-dark and disappeared. `nhc-logo-on-brand.png` is
 * a further pass over the same shape, the swoosh and wordmark pushed to
 * plain white and only the one accent dot kept, recoloured to the panel's
 * own copper rather than its original muddy orange.
 */
export function NhcLogo({
  className = '',
  alt = '',
  onDark = false,
}: {
  className?: string;
  alt?: string;
  onDark?: boolean;
}) {
  if (onDark) return <img src={nhcLogoOnBrand} alt={alt} className={className} />;
  return (
    <>
      <img src={nhcLogo} alt={alt} className={`${className} dark:hidden`} />
      <img src={nhcLogoDark} alt={alt} className={`${className} hidden dark:block`} aria-hidden={alt ? undefined : true} />
    </>
  );
}
